export type FieldCacheType = {
  deps: Array<unknown>;
  value: unknown;
  result?: unknown;
};

export const VALIDATION_ITEM_NOT_VALID = "VALIDATION_ITEM_NOT_VALID";

export const createFieldValidationCache = () => {
  const fields = new Map<string, FieldCacheType>();

  const add = (name: string, data: FieldCacheType) => {
    const { deps, value, result } = data;
    fields.set(name, {
      deps,
      value,
      result,
    });
  };

  const isFieldInvalidValid = (name: string, deps: string[] = []) => {
    const item = fields.get(name);
    if (item) {
      const sameDeps = deps.every(dep => item.deps.includes(dep));
      return sameDeps && item.result === VALIDATION_ITEM_NOT_VALID;
    }
    return false;
  };

  const addInvalidItem = (
    name: string,
    data: Omit<FieldCacheType, "result">,
  ) => {
    const { deps, value } = data;
    fields.set(name, {
      deps,
      value,
      result: VALIDATION_ITEM_NOT_VALID,
    });
  };

  const shouldRevalidate = (
    name: string,
    value: unknown,
    deps: unknown[],
  ): boolean | null => {
    const item = fields.get(name);
    if (!item) {
      fields.set(name, {
        deps,
        value,
      });
      return true;
    }
    if (item.result === VALIDATION_ITEM_NOT_VALID) {
      return false;
    }

    const sameDeps = deps.every(dep => item.deps.includes(dep));
    const hasDiffs = !sameDeps || value !== item.value;
    return hasDiffs;
  };

  const reset = () => {
    fields.clear();
  };

  return {
    add,
    isFieldInvalidValid,
    addInvalidItem,
    shouldRevalidate,
    reset,
    fields,
  };
};

const fieldValidationCache = createFieldValidationCache();

export { fieldValidationCache };
